<template>
    <div class="container">
        <div class="cart order">
            <div v-if="loaderBig" style="text-align: center">
                <img src="/uikit/svg/icons/loader.svg" alt="" style="width: 60px; height: 60px;">
            </div>

            <template v-else>
                <template v-if="cart !== null  && isCartEmpty()">
                    <EmptyCart></EmptyCart>
                </template>

                <template v-if="!isCartEmpty()">
                    <h1 class="cart__title">{{ title }}</h1>

                    <div class="grid" :class="{'disable': loader.cart}">
                        <div class="grid__col grid__col--md-8">
                            <UserComponent
                                @createLoader="createLoader">
                            </UserComponent>

                            <DeliveryComponent
                                v-if="isEquipmentInCart"
                                @createLoader="createLoader"
                                @reloadCart="reloadCart">
                            </DeliveryComponent>

                            <PaymentComponent
                                v-if="isPaymentInCart"
                                @checkPayLatter="checkPayLatter"
                                @createLoader="createLoader">
                            </PaymentComponent>

                            <NoteComponent
                                @createCommentValue="createCommentValue">
                            </NoteComponent>
                        </div>

                        <div class="grid__col grid__col--md-4">
                            <CartTotalComponent
                                :cart="cart"
                                :loader="loader"
                                @nextButtonHandler="nextButtonHandler">
                            </CartTotalComponent>
                        </div>
                    </div>
                </template>
            </template>

        </div>
    </div>
</template>

<script>

import BxBaseApp from "../../BxBaseApp.vue";
import BaseMethods from "../components/BaseMethods.vue";

import UserComponent from "../components/cart-confirm/UserComponent.vue";
import DeliveryComponent from "../components/cart-confirm/DeliveryComponent.vue";
import PaymentComponent from "../components/cart-confirm/PaymentComponent.vue";
import NoteComponent from "../components/cart-confirm/NoteComponent.vue";
import CartTotalComponent from "../components/cart-confirm/CartTotalComponent.vue";
import EmptyCart from "../components/EmptyCart.vue";

import api from '../../../lib/api'
import message from '../../../lib/message'
import utils from "../../../lib/utils";

const PAY_LATER = '1'; //Константа ID оплаты позднее

export default {
    name: 'CartConfirm',
    components: {
        CartTotalComponent,
        UserComponent,
        DeliveryComponent,
        PaymentComponent,
        NoteComponent,
        EmptyCart,
    },
    mixins: [BxBaseApp, BaseMethods],
    data() {
        return {
            cart: null,
            userLogin: null,
            loaderBig: true,
            loader: {
                cart: true,
            },
            isEquipmentInCart: false,
            isPaymentInCart: false,
            comment: '',
            isConfirmPage: true
        }
    },
    props: {
        isMobile: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        title() {
            if (this.$route) {
                return this.$route.meta.title
            }
            return null
        }
    },
    methods: {
        checkPayLatter(payId) {
            this.cart['PAY_LATER'] = payId === PAY_LATER;
        },
        nextButtonHandler() {
            window.mgoTriggerEvent('order-confirm');
            this.checkBeforeOrder(this.doOrder);
        },
        doOrder() {
            const t = this;
            const sendData = {
                'backurl': location.href,
                'comment': t.comment
            };

            t.loader.cart = true

            api.request('/api/order/createOrder/', 'post', sendData).then((response) => {

                console.log('doOrder', response);
                window.mgoTriggerEvent('do-order', [response?.data]);

                if (response?.data['content'] && response?.data['content'] !== undefined) {
                    if (response?.data['link']) {
                        let form = document.createElement('form');
                        form.setAttribute('method', 'POST');
                        form.setAttribute('action', response?.data['link']);
                        form.innerHTML = response?.data['content'];
                        let sel = form.querySelectorAll('input[name="LMI_PAYMENT_NO"]');
                        if (sel.length > 0) {
                            sel[0].setAttribute('value', t.userLogin);
                        }

                        form.style = 'display:none';
                        document.body.appendChild(form);
                        form.submit();
                    } else {
                        message.showError('Ошибка при попытке отправки на платёжный шлюз');
                    }
                } else {
                    if (response?.data['link']) {
                        window.location.href = response?.data['link']
                    }
                }
            }).catch((error) => {
                let response = error.response.data;
                switch (response?.data['error_type']) {
                    case 'busy_numbers':
                    case 'stop_8_800_phis':
                    case 'external_error':
                        api.request(
                            '/ajax_new/cookieFunctions.php',
                            'post',
                            {
                                action: 'set',
                                name: response?.data['error_type'] === 'external_error' ? 'ARR_EXTERNAL_ERROR' : 'ARR_BUSY_NUMBERS',
                                value: encodeURIComponent(response?.data['numbers']),
                                time: 3600
                            },
                        );
                        t.stopReloadCart();
                        message.showError(response?.errors[0]['message']);
                        break;
                    case 'test_offers':
                        t.reloadCart();
                        t.stopReloadCart();
                        message.showError(response?.errors[0]['message']);
                        break;
                    case 'no_pay_system':
                        t.stopReloadCart();
                        message.showError('Выберите способ оплаты');
                        break;
                    default:
                        t.stopReloadCart();
                        message.showError(response?.errors[0]['message'] ?? 'Ошибка при отправке заказа');
                }
            });

        },
        reloadCart() {
            const sendData = {
                isReload: 'Y'
            }

            this.loader.cart = true;

            api.request(this.apiUrl + 'getData/', 'post', sendData).then((response) => {
                this.cart = response.data.cart
                this.loader.cart = false;
            }).catch(() => {
                const alertMessage = 'Ошибка при обновлении корзины'
                message.showError(alertMessage)
                this.stopReloadCart();
            });
        },
        stopReloadCart() {
            Object.keys(this.loader).forEach(item => {
                this.loader[item] = false;
            })
        },
        createCommentValue(value) {
            this.comment = value;
        },
        createLoader(key, value) {
            this.loader.cart = value;
            this.loader[key] = value;
        }
    },
    mounted() {
        this.initData()
            .finally(() => {
                let intervalId = setInterval(() => {
                    Object.keys(this.loader).forEach(item => {
                        if (this.loader[item]) {
                            return false;
                        }
                    });

                    clearInterval(intervalId);
                    this.loaderBig = false;
                }, 1000);
            })
    }
}
</script>

<style lang="scss">
@import "../../../../../design_kit/site/blocks/order/style.scss";
@import "../../../../../design_kit/site/blocks/input/light-theme.scss";
@import "../../../../../design_kit/site/blocks/list/style.scss";
@import "../../../../../design_kit/site/base/svg-font.css";
@import "../../../../../design_kit/site/blocks/icon/style.scss";
@import "../../../../../design_kit/site/blocks/sel/style.scss";
@import "../../../../../design_kit/site/blocks/payment/style.scss";
@import "../../../../../design_kit/site/blocks/delivery/style.scss";
@import "../../../../../design_kit/site/blocks/order/style.scss";

.disable-div {
    pointer-events: none;
}
</style>
